import React from 'react';

interface CustomModalProps {
    title: string;
    message: string;
    onClose: () => void;
}

const CustomModal = ({ title, message, onClose }: CustomModalProps) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 text-center">
                <h2 className="text-xl font-semibold mb-4">{title}</h2>
                <p className="mb-6 text-gray-700">{message}</p>
                <button
                    onClick={onClose}
                    className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition"
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

export default CustomModal;
